import { concat, fn } from '@ember/helper';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { t } from 'ember-intl';
import PowerSelect from 'ember-power-select/components/power-select';

import { labelValueOptions } from 'umg-ember-backend/utils/intl';

export default class RecordExplorerToolbarFiltersSelectValueLabelComponent extends Component {
  // Services
  @service intl;

  // Getter and setter
  get options() {
    const { recordType } = this.args;
    const key = this.args.filter.key;

    return labelValueOptions.call(this, this.args.filter.options, [
      `tables.${recordType}.filterOptions.${key}`,
      `tables.defaults.filterOptions.${key}`,
      `forms.${recordType}.options.${key}`,
      `forms.defaults.options.${key}`,
    ]);
  }

  get selected() {
    let value = this.args.activeFilters[this.args.filter.key];

    // We can't use === because queryParams from the route service are always strings
    return this.options.find((option) => option.value == value);
  }

  // Functions
  setFilter = (filter, selected) => {
    let filters = this.args.activeFilters;

    if (selected) {
      filters[filter.key] = selected.value;
    } else {
      delete filters[filter.key];
    }

    this.args.onChangeFilter(filters);
  };

  // Template
  <template>
    <PowerSelect
      @allowClear={{true}}
      @options={{this.options}}
      @selected={{this.selected}}
      @searchEnabled={{true}}
      @searchField='label'
      @placeholder={{t
        'tables.placeholder-filter'
        filter=(t (concat 'tables.filters.' @filter.key))
      }}
      @onChange={{fn this.setFilter @filter}}
      as |option|
    >
      {{option.label}}
    </PowerSelect>
  </template>
}
